import { useEffect, useState } from "react"
import { getAllAccesses, setRoleAccess } from "../Common/rolesAccessSlice"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../store/Store"
import RoleAccess from "../Common/roleAccess"

const useAccountsAccess = () => {
    const [viewAccountsTable, setViewAccountsTable] = useState(true)
    const [viewVendorTable, setViewVendorTable] = useState(true)
    const [viewClientTable, setViewClientTable] = useState(true)
    const [viewAllAccountsTable, setViewAllAccountsTable] = useState(true)
    const [downloadAccountPermission, setDownloadAccountPermission] = useState(true)
    const [addAccountsPermission, setAddAccountsPermission] = useState(false)
    const [addAllAccountsPermission, setAddAllAccountsPermission] = useState(false)
    const [addClientAccountsPermission, setAddClientAccountsPermission] = useState(false)
    const [addVendorAccountsPermission, setAddVendorAccountsPermission] = useState(false)
    const [editAccountsPermission, setEditAccountsPermission] = useState(false)
    const [editAllAccountsPermission, setEditAllAccountsPermission] = useState(false)
    const [editClientAccountsPermission, setEditClientAccountsPermission] = useState(false)
    const [editVendorAccountsPermission, setEditVendorAccountsPermission] = useState(false)

    const [deleteAllAccountsPermission, setDeleteAllAccountsPermission] = useState(false)
    const [deleteClientAccountsPermission, setDeleteClientAccountsPermission] = useState(false)
    const [deleteVendorAccountsPermission, setDeleteVendorAccountsPermission] = useState(false)
    const [addAccountsProjectsPermission, setAddAccountsProjectsPermission] = useState(false)
    const [addTagAccess, setAddTagAccess] = useState(false)
    const [viewTagAccess, setViewTagAccess] = useState(false)
    const [editTagAccess, setEditTagAccess] = useState(false)
    const [deleteTagIdAccess, setDeleteTagIdAccess] = useState(false)
    const allAccesses: any = useSelector(getAllAccesses)
    const {
        loginData: { user_data },
    } = useSelector((store: any) => store.verifyLogin)

    const dispatch = useDispatch<AppDispatch>()

    const allRoleAccess = RoleAccess()
    const rolesObjValues: any = Object.values(allRoleAccess)

    const getModulesArr = () => {
        const rolesData = rolesObjValues?.filter((rolesdetail: any) => rolesdetail.module_id === 14)
        return rolesData
    }

    useEffect(() => {
        //For superadmin only
        if (user_data?.role_id === 1 || user_data?.role_id === 51) {
            setEditAccountsPermission(true)
        } else setEditAccountsPermission(false)
    }, [user_data])

    const handleAccessControl = () => {
        setAddAccountsPermission(false)
        setEditAccountsPermission(false)
        setViewAccountsTable(false)
        setViewAllAccountsTable(false)
        setViewClientTable(false)
        setViewVendorTable(false)
        setEditAllAccountsPermission(false)
        setEditClientAccountsPermission(false)
        setEditVendorAccountsPermission(false)
        setDeleteAllAccountsPermission(false)
        setDeleteClientAccountsPermission(false)
        setDeleteVendorAccountsPermission(false)
        setAddAllAccountsPermission(false)
        setAddClientAccountsPermission(false)
        setAddVendorAccountsPermission(false)
        setAddAccountsProjectsPermission(false)
        setDownloadAccountPermission(false)
        setAddTagAccess(false)
        setEditTagAccess(false)
        setViewTagAccess(false)
        setDeleteTagIdAccess(false)
        if (allAccesses?.data?.length) {
            allAccesses?.data?.forEach((permission: any) => {
                switch (permission?.title) {
                    case "Add Account":
                        setAddAccountsPermission(permission?.value)
                        break
                    case "Edit Account":
                        setEditAccountsPermission(permission?.value)
                        break
                    case "List Accounts":
                        setViewAccountsTable(permission?.value)
                        break
                    case "View All Accounts":
                        setViewAllAccountsTable(permission?.value)
                        break
                    case "View Client Accounts":
                        setViewClientTable(permission?.value)
                        break
                    case "View Vendor Accounts":
                        setViewVendorTable(permission?.value)
                        break
                    case "Edit All Accounts":
                        setEditAllAccountsPermission(permission?.value)
                        break
                    case "Edit Client Accounts":
                        setEditClientAccountsPermission(permission?.value)
                        break
                    case "Edit Vendor Accounts":
                        setEditVendorAccountsPermission(permission?.value)
                        break
                    case "Delete All Accounts":
                        setDeleteAllAccountsPermission(permission?.value)
                        break
                    case "Delete Client Accounts":
                        setDeleteClientAccountsPermission(permission?.value)
                        break
                    case "Delete Vendor Accounts":
                        setDeleteVendorAccountsPermission(permission?.value)
                        break
                    case "Add All Accounts":
                        setAddAllAccountsPermission(permission?.value)
                        break
                    case "Add Client Accounts":
                        setAddClientAccountsPermission(permission?.value)
                        break
                    case "Add Vendor Accounts":
                        setAddVendorAccountsPermission(permission?.value)
                        break
                    case "Add Account From Projects":
                        setAddAccountsProjectsPermission(permission?.value)
                        break
                    case "Export":
                        setDownloadAccountPermission(permission?.value)
                        break
                    case "Add Tag":
                        setAddTagAccess(permission?.value)
                        break;
                    case "Map Tag":
                    setEditTagAccess(permission?.value)
                        break;
                    case "View Tag":
                        setViewTagAccess(permission?.value)
                        break;
                    case "Unmap Tag":
                    setDeleteTagIdAccess(permission?.value)
                        break;

                }
            })
        } else {
            setAddAccountsPermission(false)
            setViewAccountsTable(false)
            setAddAccountsProjectsPermission(false)
            setEditAccountsPermission(false)
            setViewClientTable(false)
            setViewVendorTable(false)
            setViewAllAccountsTable(false)
            setDownloadAccountPermission(false)
        }
    }

    useEffect(() => {
        const modulesArr: any = getModulesArr()
        dispatch(setRoleAccess(modulesArr))
        handleAccessControl()
    }, [allAccesses?.data])

    return {
        viewAccountsTable,
        addAccountsPermission,
        editAccountsPermission,
        addAccountsProjectsPermission,
        viewClientTable,
        viewVendorTable,
        downloadAccountPermission,
        viewAllAccountsTable,
        viewTagAccess,
        addTagAccess,
        editTagAccess,
        deleteTagIdAccess,
        addAllAccountsPermission,
        addClientAccountsPermission,
        addVendorAccountsPermission,
        editAllAccountsPermission,
        editClientAccountsPermission,
        editVendorAccountsPermission,
        deleteAllAccountsPermission,
        deleteClientAccountsPermission,
        deleteVendorAccountsPermission
    }
}

export default useAccountsAccess
